import { io } from "socket.io-client";

const prodUrl = process.env.REACT_APP_SERVER_URL || "";

// The URL of your backend server
const URL =
  process.env.REACT_APP_NODE_ENV === "localhost"
    ? "http://localhost:4000"
    : prodUrl;

export const socket = io(URL, {
  autoConnect: false, // We'll connect manually
});
